import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6518cc7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon" }
const _hoisted_2 = ["src"]

import { computed, ref, watchEffect } from 'vue'
import { usePolicyConfig } from '..'
import { ApplicationPolicySchema, MdmApplicationInputSchema, MdmApplicationSchema } from '@/generated/sdk'
import { ConfigProperty, createApplicationConfig } from './config'
import { sdk } from '@/store/api'


export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyConfigurationApplications',
  props: {
    applicationList: {},
    editMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { policyConfig, getMdmApplicationsData } = usePolicyConfig()
const policyApplications = computed<ApplicationPolicySchema[]>(() => policyConfig.value?.applications ?? [])



const applicationConfig = ref<ConfigProperty[]>(createApplicationConfig())
const showForm = ref(false)
const hasErrors = ref(false)
const editApplicationIndex = ref(-1)

const tableData = ref<MdmApplicationSchema[]>(null)

watchEffect(async () => {
  if (props.applicationList == null) return
  await tryGetMdmApplicationsData()
})

async function tryGetMdmApplicationsData() {
  try {
    const input = props.applicationList.map(application => ({
      name: application.packageName,
    })) as MdmApplicationInputSchema[]
    tableData.value = await getMdmApplicationsData(input)
  } catch (error) {
    tableData.value = []
  }
}

function editApplication(index: number) {
  const application = policyApplications.value[index]
  setFormValues(application)
  editApplicationIndex.value = index
  showForm.value = true
}

function removeApplication(index: number) {
  const newApplicationsConfig = policyApplications.value.toSpliced(index, 1) ?? null
  policyConfig.value.applications = newApplicationsConfig
}

async function saveApplication() {
  const packageName = applicationConfig.value.find(property => property.id === 'packageName')
  if (packageName.value == null || packageName.value === '') return (packageName.error = true)

  try {
    await sdk().mdmApplication({ input: { name: packageName.value } })
  } catch (e) {
    return (packageName.error = true)
  }

  // if the policy does not have an applications array, create it
  if (policyConfig.value.applications == null) {
    policyConfig.value.applications = []
  }

  // parse properties according to their type
  const application: ApplicationPolicySchema = {}
  applicationConfig.value.forEach(property => {
    if (property.type === 'json') {
      property.value = JSON.parse(property.value)
    }
    if (property.type === 'multiselect') {
      if (Array.isArray(property.value) && property.value.length === 0) {
        property.value = null
      }
    }
    application[property.id] = property.value
  })

  // add the application to the policy
  // if we are editing an application, replace it
  if (editApplicationIndex.value === -1) {
    policyConfig.value.applications.push(application)
  } else {
    policyConfig.value.applications[editApplicationIndex.value] = application
  }

  resetForm()
}

function setFormValues(application: ApplicationPolicySchema) {
  applicationConfig.value.forEach(property => {
    if (application[property.id] == null) return

    if (property.type === 'json') {
      property.value = JSON.stringify(application[property.id], null, 2)
    } else {
      property.value = application[property.id]
    }
  })
}

function resetForm() {
  applicationConfig.value = createApplicationConfig()
  editApplicationIndex.value = -1
  showForm.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DodoSpinner = _resolveComponent("DodoSpinner")!
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!
  const _component_FormBuilder = _resolveComponent("FormBuilder")!
  const _component_PrimeDialog = _resolveComponent("PrimeDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DodoColumn, null, {
      default: _withCtx(() => [
        (tableData.value !== null && tableData.value.length > 0)
          ? (_openBlock(), _createBlock(_component_DataTable, {
              key: 0,
              value: tableData.value,
              class: _normalizeClass(["data-table", { 'no-margin': !_ctx.editMode }])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PrimeColumn, {
                  style: {"width":"96px"},
                  "header-class": "no-header"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("img", {
                        src: data.iconUrl
                      }, null, 8, _hoisted_2)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeColumn, {
                  field: "title",
                  "header-class": "no-header"
                }),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock(_component_PrimeColumn, {
                      key: 0,
                      "header-class": "no-header",
                      class: "text-right"
                    }, {
                      body: _withCtx(({ index }) => [
                        _createVNode(_component_DodoButton, {
                          rounded: "",
                          variant: "text",
                          onClick: ($event: any) => (editApplication(index))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DodoIcon, { name: "edit" }),
                            _createTextVNode(" Edit ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_DodoButton, {
                          rounded: "",
                          variant: "text",
                          color: "danger",
                          onClick: ($event: any) => (removeApplication(index))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DodoIcon, { name: "delete" }),
                            _createTextVNode(" Remove ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["value", "class"]))
          : _createCommentVNode("", true),
        (_ctx.applicationList !== null && tableData.value == null)
          ? (_openBlock(), _createBlock(_component_DodoRow, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_DodoSpinner)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.editMode)
          ? (_openBlock(), _createBlock(_component_DodoRow, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_DodoButton, {
                  class: "add-button",
                  variant: "solid",
                  color: "success",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showForm.value = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DodoIcon, { name: "add" }),
                    _createTextVNode(" Add application ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_PrimeDialog, {
      visible: showForm.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showForm).value = $event)),
      modal: "",
      header: editApplicationIndex.value >= 0 ? 'Edit Application' : 'New application',
      style: { width: '65vw' },
      breakpoints: { '960px': '75vw', '641px': '100vw' },
      onHide: _cache[4] || (_cache[4] = ($event: any) => (resetForm()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormBuilder, {
          "config-properties": applicationConfig.value,
          "onUpdate:configProperties": _cache[1] || (_cache[1] = ($event: any) => ((applicationConfig).value = $event)),
          "has-errors": hasErrors.value,
          "onUpdate:hasErrors": _cache[2] || (_cache[2] = ($event: any) => ((hasErrors).value = $event))
        }, null, 8, ["config-properties", "has-errors"]),
        _createVNode(_component_DodoButton, {
          variant: "solid",
          color: "info",
          disabled: hasErrors.value,
          onClick: saveApplication
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Save application ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}
}

})